/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { NodesPageTabs } from '@/components/NodesPageTabs/NodesPageTabs';
import { NodesPageTab, NodesPageTabCounts, NodesPageTabLoading } from '@/components/NodesPageTabs/types';
import { PageHeader } from '@/components/PageHeader';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Col } from '@/primitives/Col';
import { Row } from '@/primitives/Row';

import './NodesHeader.css';

// Re-export for backwards compatibility
export { NodesPageTab as NodeFilter } from '@/components/NodesPageTabs/types';

export type NodesHeaderProps = {
  activeTab: NodesPageTab;
  counts: NodesPageTabCounts;
  loading: NodesPageTabLoading;
  onTabChange: (tab: NodesPageTab) => void;
};

export function NodesHeader({ activeTab, counts, loading, onTabChange }: NodesHeaderProps) {
  const { t: tNodes } = useMimicTranslation('nodes');
  const { t: tFleets } = useMimicTranslation('fleets');

  return (
    <Row justify="space-between" align="middle" gutter={[16, 16]} style={{ margin: 0 }}>
      <Col xs={24} md={12} style={{ padding: 0 }}>
        <PageHeader title={activeTab === NodesPageTab.FLEETS ? tFleets('title') : tNodes('title')} level={2} />
      </Col>
      <Col xs={24} md={12} xl={10} xxl={8} style={{ padding: 0 }}>
        <NodesPageTabs activeTab={activeTab} counts={counts} loading={loading} onTabChange={onTabChange} />
      </Col>
    </Row>
  );
}
